// Admin team role catalog — Dalga 3a (migration 255).
//
// Single source for the governed team-surface role list and its i18n label /
// scope-hint lookup, shared by the invite modal, the member inspector's role
// preset select, the team filter and the profile display. Non-component
// module on purpose (react-refresh only-export-components).

import type { AdminRoleTier } from '../../../api/admin-users'

/** Display order — owner first, then the preset staff roles by breadth. */
export const TEAM_ROLE_OPTIONS: readonly AdminRoleTier[] = [
  'a1_platform_owner',
  'a2_internal_staff',
  'a2_ops',
  'a2_finance',
  'a2_readonly',
]

const LABEL_KEY: Record<AdminRoleTier, string> = {
  a1_platform_owner: 'platformOwner',
  a2_internal_staff: 'internalStaff',
  a2_ops: 'roleOps',
  a2_finance: 'roleFinance',
  a2_readonly: 'roleReadonly',
}

const HINT_KEY: Partial<Record<AdminRoleTier, string>> = {
  a2_internal_staff: 'roleInternalStaffHint',
  a2_ops: 'roleOpsHint',
  a2_finance: 'roleFinanceHint',
  a2_readonly: 'roleReadonlyHint',
}

export function roleLabel(tier: string, t: Record<string, string>): string {
  const key = LABEL_KEY[tier as AdminRoleTier]
  return key ? t[key] : tier.replaceAll('_', ' ')
}

/** Short scope description for the role, or null (owner needs no hint). */
export function roleHint(tier: string, t: Record<string, string>): string | null {
  const key = HINT_KEY[tier as AdminRoleTier]
  return key ? t[key] : null
}
